import React from 'react';
import '../../styles/HeroScreen.css';

export default function HeroScreen({ 
  title, 
  text, 
  image,
  fullWidthImg,
  imageStyles
}) {
  return (
    <div 
      className="hero-screen" 
    >
      <div className="hero-content">
        
        {title && <div
          className={`
            hero-title 
            font-${title?.fontSize ?? "font-md"}
            text-${title?.textAlign ?? "text-left"}
          `}
          dangerouslySetInnerHTML={{__html: title.value}}>
        </div>}

        {text && <div
          className={`
          hero-text font-${text?.fontSize ?? "md"}
          text-${text?.textAlign ?? "text-left"}`}
          dangerouslySetInnerHTML={{__html: text.value}}>
        </div>}

      </div>

      <img
          className={`hero-img ${fullWidthImg ? 'hero-full-width' : ''}`}
          src={image}
          alt=""
          style={imageStyles || undefined}
        />
    </div>
  );
}